package com.narbase.letsgo.web.views.driverGroups

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.percent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.dto.enum
import com.narbase.letsgo.web.models.TargetsStatus
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.table.headerCell
import com.narbase.letsgo.web.utils.table.listTable
import com.narbase.letsgo.web.utils.table.tableCell
import com.narbase.letsgo.web.utils.table.tableRow
import com.narbase.letsgo.web.utils.verticalSeparator
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.views.bankilyTransfers.AssignTransferToDriverDialog
import com.narbase.letsgo.web.views.bankilyTransfers.BankilyTransfersManagementViewModel
import com.narbase.letsgo.web.views.driverTargets.UpsertTargetDialog
import com.narbase.letsgo.web.views.driverTargets.targetConfig.TargetConfigDialog

class DriverGroupsManagementComponent : Component() {

    private var paginationControls: PaginationControls? = null
    private val viewModel = DriverGroupsManagementViewModel()

    private var listTableBody: View? = null

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getList()
    }

    private fun onListLoaded() {
        paginationControls?.update(viewModel.pageNo, viewModel.pageSize, viewModel.total)
        listTableBody?.clearAllChildren()
        listTableBody?.apply {
            viewModel.data.forEachIndexed { index, item ->
                tableRow {
                    tableCell(item.name ?: "-", 1, 14.px)
                    tableCell(item.purpose.enum().dtoName, 1, 14.px)


                    onClick = {
                        //toDo: edit
                        UpsertDriverGroupDialog(
                            driverGroup = item,
                            onUpdated = {
                                viewModel.getList()
                            }
                        ).show()
                    }
                }

                if (index != viewModel.data.lastIndex) {
                    verticalSeparator()
                }
            }
        }
    }

    override fun View?.getView() = view {
        id = "DriverGroupManagementRootView"
        style {
            matchParentDimensions
        }
        scrollable {
            style {
                matchParentDimensions
            }

            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }

                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    textView {
                        text = "Driver Groups (Multipurpose)".localized()
                        style {
                            width = wrapContent
                            fontSize = 20.px
                            fontWeight = "bold"
                        }
                    }

                    horizontalFiller()
                    addItemButton()
                }

                horizontalLayout {
                    style {
                        width = matchParent
                        marginTop = 16.px
                    }
                    horizontalFiller()
                    searchTextInput("Search".localized()) {
                        viewModel.searchFor(it)
                    }
                }

                verticalLayout {
                    matchParentDimensions()
                    withLoadingAndError(viewModel.uiState,
                        onRetryClicked = { viewModel.getList() },
                        onLoaded = { onListLoaded() })

                    listTableBody = listTable {
                        headerCell("Name".localized(), 1)
                        headerCell("Purpose".localized(), 1)
                    }
                    paginationControls = setupPaginationControls(viewModel::getNextPage, viewModel::getPreviousPage)
                }
            }
        }
    }

    private fun LinearLayout.addItemButton() {
        theme.mainButton(this) {
            id = "AddGroupButton"
            onClick = {
                UpsertDriverGroupDialog(null, onUpdated = {
                    viewModel.getList()
                }).show()
            }
            text = "+ Add new group"
        }
    }
}